<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item>模板管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">模板管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handelToGoCreate"
          >添加模板</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="模板名称">
          <el-input
            v-model.trim="query.TemplateNameKeyword"
            placeholder="输入订单编号"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            v-model="query.AuditStatus"
            clearable
            placeholder="请选择"
            style="width: 150px"
            @change="fetchList(true)"
          >
            <el-option
              v-for="item in filter.AuditStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型">
          <el-select
            v-model="query.TemplateType"
            clearable
            placeholder="请选择"
            style="width: 150px"
            @change="fetchList(true)"
          >
            <el-option
              v-for="item in filter.TemplateType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="results card">
      <div class="values-header">
        <p class="title">模板列表</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            label="模板名称"
            align="center"
            prop="TemplateName"
            show-overflow-tooltip
            min-width="350"
          >
          </el-table-column>
          <el-table-column
            label="工单号"
            prop="OrderId"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            label="模板CODE"
            align="center"
            width="200"
            prop="TemplateCode"
          >
          </el-table-column>
          <el-table-column
            label="短信类型"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.TemplateType==0">验证码</div>
              <div v-if="scope.row.TemplateType==1">短信通知</div>
              <div v-if="scope.row.TemplateType==2">推广短信</div>
              <div v-if="scope.row.TemplateType==3">国际/港澳台消息</div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建人"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <div>{{scope.row.creator?scope.row.creator.nickname:'暂无'}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="200"
            align="center"
            prop="CreateDate"
          >
            <!--     <template slot-scope="scope">
              <span>{{ $moment(scope.row.update_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template> -->
          </el-table-column>
          <el-table-column
            label="审核状态"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                type="warning"
                v-if="scope.row.AuditStatus=='AUDIT_STATE_INIT'"
              >审核中</el-tag>
              <el-tag
                size="mini"
                type="success"
                v-if="scope.row.AuditStatus=='AUDIT_STATE_PASS'"
              >通过</el-tag>
              <el-tag
                size="mini"
                type="danger"
                v-if="scope.row.AuditStatus=='AUDIT_STATE_NOT_PASS'"
              >未通过</el-tag>
              <el-tag
                size="mini"
                type="info"
                v-if="scope.row.AuditStatus=='AUDIT_STATE_CANCEL'"
              >取消</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="300"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleToDetail(scope.row)"
              >详情</el-link>
              <el-link
                type="primary"
                :underline="false"
                @click="handleToEdit(scope.row)"
                v-if="scope.row.AuditStatus=='AUDIT_STATE_NOT_PASS'"
              >查看原因并修改</el-link>
              <el-link
                type="primary"
                :underline="false"
                @click="handleToClone(scope.row)"
                v-if="scope.row.AuditStatus=='AUDIT_STATE_PASS'"
              >克隆</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row.TemplateCode)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <TemplateDetail
      :visible="detailDialog"
      :content="detailContent"
      @close="detailDialog=false"
    />
  </div>
</template>

<script>
import { smsTemplatelist, smsTemplateDelete, smsTemplateCreate } from "@/api/operation";
import TemplateDetail from "@/components/dialog/template/TemplateDetail";


let Timer = null       // 定时器
let TimerTime = 1000    // 定时器 等待时长
export default {
  components: {
    TemplateDetail
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      detailDialog: false,
      detailContent: {},
      filter: {
        AuditStatus: [
          { label: "审核中", value: "AUDIT_STATE_INIT" },
          { label: "通过", value: "AUDIT_STATE_PASS" },
          { label: "未通过", value: "AUDIT_STATE_NOT_PASS" },
          { label: "取消", value: "AUDIT_STATE_CANCEL" },
        ],
        TemplateType: [
          { label: "推广短信", value: 2 },
          { label: "通知短信", value: 1 },
        ],
      }
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      smsTemplatelist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数  
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handelToGoCreate() {
      this.$router.push('/template/create')
    },
    handleToDetail(row) {
      this.detailContent = Object.assign({}, row)
      this.detailDialog = true
    },
    handleToRemove(TemplateCode) {
      this.$confirm("确定要删除此条模板吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        smsTemplateDelete({ TemplateCode }).then((res) => {
          this.fetchList(true);
        });
      })
    },
    handleToEdit(row) {
      this.$router.push(`/template/edit?detail=${JSON.stringify(row)}`)
    },
    handleToClone(row) {
      this.$confirm("确定要克隆此条模板吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const data = {
          TemplateType: row.TemplateType,
          TemplateName: row.TemplateName,
          TemplateContent: row.TemplateContent,
        }
        smsTemplateCreate(data).then((res) => {
          if (res.Code == 'OK') {
            this.$message.success('创建成功')
            this.fetchList()
          }
        });
      })
    },
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchList(true)
      }, TimerTime)
    },
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-link {
    font-size: 14px;
    margin: 0px 5px;
  }
}
</style>
